<script setup lang="ts">
import { ref } from 'vue';
import { NxtSelect } from '@future-harry/nxt-styles';

export interface City {
   id: number;
   name: string;
}

const selectedCity = defineModel<City | null>({ required: true });

const lastSearchResults = ref<City[]>([]);

async function customSearch(searchValue: string) {
   if (!searchValue || searchValue.trim().length < 2) return [];

   const { data } = await useFetch<any>(`/nxt-cities?search=${searchValue}`);

   const searchResults =
      data.value?.data?.map((city: any) => ({
         id: city.id,
         name: `${city.name} ${city.postal_code}`,
      })) || [];

   lastSearchResults.value = searchResults;

   return searchResults;
}

function selectCity(id: number | null) {
   if (id === null) {
      selectedCity.value = null; // reset selected city, value is watched to refresh jobs (in useJobs)
      return;
   }

   const cityData = lastSearchResults.value.find((c) => c.id === id);
   if (!cityData) return;

   selectedCity.value = {
      id: cityData.id,
      name: cityData.name,
   };
}

function clearCity() {
   selectedCity.value = null;
}
</script>

<template>
   <div class="city-selector">
      <NxtSelect
         :name="'city-selector'"
         :model-value="selectedCity?.id"
         search-type="custom"
         :search-on-open="false"
         :has-clear-option="true"
         :custom-search="customSearch"
         :placeholder="$t('components.city-selector.placeholder')"
         @update:model-value="selectCity"
         @clear="clearCity"
      />
   </div>
</template>

<style scoped lang="scss">
.city-selector {
   display: flex;
   flex-direction: column;
   gap: var(--nxt-gutter-large);

   :deep(.nxt-select) {
      input {
         background-color: #fff;
      }
   }
}
</style>
